import React, { useState } from 'react';
import CheckboxButton from '../../../CheckboxButton';

const ListSelectControlsItem = props => {
  const { disabled, controlFunc } = props;
  const [checked, setChecked] = useState(false);

  const onClick = () => {
    if (!disabled) {
      controlFunc(!checked);
      setChecked(!checked);
    }
  };

  const icon = checked ? props.iconActive : props.icon;
  const text = checked ? props.captionActive : props.caption;

  return <CheckboxButton caption={text} icon={icon} controlFunc={onClick} />;
};

export default ListSelectControlsItem;
